export const PERSONAL_PROJECT_SCOPE = "personal" as const;

export type ProjectOrganizationScope =
  | string
  | typeof PERSONAL_PROJECT_SCOPE;

export type ProjectAccessLevel = "owner" | "admin" | "modifier" | "viewer";

export type ProjectDto = {
  id: string;
  name: string;
  description?: string | null;
  is_owner?: boolean;
  access_level?: string | null;
  created_at?: string | null;
  ap_project_id?: string | null;
  organization_id?: string | null;
  user_id?: string | null;
};

export type Project = {
  id: string;
  name: string;
  description: string;
  isOwner: boolean;
  accessLevel: ProjectAccessLevel | null;
  createdAt: string | null;
  apProjectId: string | null;
  organizationId: string | null;
  userId: string | null;
};

export type ProjectListParams = {
  skip?: number;
  limit?: number;
  includeShared?: boolean;
  includeDeleted?: boolean;
};

export type NormalizedProjectListParams = Required<ProjectListParams>;

export type ProjectListScope = {
  principalId: string;
  organizationId: ProjectOrganizationScope;
};

export type CreateProjectInput = {
  name: string;
  description?: string;
  teamMembers?: string[];
};

export type UpdateProjectInput = {
  projectId: string;
  name: string;
  description?: string;
};

export type DeleteProjectInput = {
  projectId: string;
  permanent?: boolean;
  force?: boolean;
};
